import { Box, Flex, Loader, Title } from '@mantine/core';
import { useState } from 'react';

import { PredictedDistanceWithDutiesAndAntiDumping } from '@e-origin/shared';

import { useGoodsItemPredictedDistances } from '@hooks/declaration';
import { HSCodeRecommendation } from './HSCodeRecommendation';

export const HSCodeRecommendations = ({ declarationId, goodDetailsId }: { declarationId: string; goodDetailsId: string }) => {
  const [selectedRecommendation, setSelectedRecommendation] = useState<PredictedDistanceWithDutiesAndAntiDumping>(null);
  const { data: predictedDistances, isLoading } = useGoodsItemPredictedDistances(declarationId, goodDetailsId);
  const handleClick = (selected: PredictedDistanceWithDutiesAndAntiDumping) => setSelectedRecommendation(selected);

  if (isLoading) {
    return (
      <Flex align="center" justify="center">
        <Loader />
      </Flex>
    );
  }

  return (
    <Box maw="50%">
      <Title order={1} fw={600} fz={14} mb={10} mt={2}>
        Predictions:
      </Title>
      <Box pos={'relative'} h={250}>
        {selectedRecommendation && <HSCodeRecommendation value={selectedRecommendation} expanded={true} onClick={handleClick} />}
        <Box pos={'relative'} h={'100%'} style={{ overflow: 'auto' }}>
          {predictedDistances.map((value, idx) => (
            <HSCodeRecommendation data-pw={idx} key={idx} value={value} onClick={handleClick} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
